import React from 'react';
import { useCaseSocket } from '../../../lib/socketHooks';
import { useSelector } from 'react-redux';
import Card from '../../common/Card';
import PannelBody from '../../fragments/PannelBody';
import classes from './SocketIntegration.module.css';
import { useIdleStatus, useCaseUpdated, useSystemSettingsUpdated } from '../../../lib/socketHooks';
import BodySimpleModalV3 from '../../common/modal/BodySimpleModalV3';
import { getInitialsColor } from '../../../lib/misc';

export default function SocketIntegration() {

    function getInitials(name) {

        if (name?.split(' ')[1]) {
            return name?.split(' ')[0][0] + name?.split(' ')[1][0]
        } else {
            return name?.split(' ')[0][0]
        }
    }

    const user = useSelector(state => state.user.user)
    const activeCase = useSelector(state => state.case.activeCase)

    const caseId = activeCase?.case?.id

    const { users, isConnected, tabSwitched } = useCaseSocket(caseId, user);
    useIdleStatus(caseId, user);
    useCaseUpdated(caseId);
    useSystemSettingsUpdated();

    // console.log('users', users)
    return (
        <Card>       

            <PannelBody>
                <div className='flex-container flex-container-space-betwen'>
                    <h3>
                        Currently Viewing 
                        {/* ({users.length}) */}
                    </h3>
                    <div className={classes.items_container}>
                        {users && users.length > 0 && users.map(user => (
                            // style={{backgroundColor: getInitialsColor(user?.name)}}
                            <div key={user.socketId} className={`${classes.item} ${user.status ? classes[user.status] : ''}`} style={{backgroundColor: getInitialsColor(user?.name)}}>
                                <BodySimpleModalV3 message={`${user?.name}`} widthAuto={true}>
                                    <div className={classes.initials} >
                                        {/* {user?.name?.split(' ')[0][0] + user?.name?.split(' ')[1][0]} */}
                                        {getInitials(user?.name)}
                                    </div>
                                </BodySimpleModalV3>
                            </div>
                        ))}
                    </div>
                </div>
            </PannelBody>
        </Card>
    );
}
